var React = require('react');

function BurgerClose (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M27.4062 27.4062L12.3125 12.3125M27.4062 12.3125L12.3125 27.4062","stroke":"#423D81","strokeWidth":"2.15625","strokeLinecap":"round","strokeLinejoin":"round"}));
}

BurgerClose.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = BurgerClose;

BurgerClose.default = BurgerClose;
